import { UserOrganizationModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class UserOrganizationODataRepo extends BaseODataRepository<UserOrganizationModel> {
  protected baseUrl = `/OData/userorganizations`;
}
